<template>
  <div id="app">
    <div class="container full-width">
      <!-- Header -->
      <header class="header">
        <div class="logo-container">
          <img
            src="https://i.ibb.co/1Y6F3CPb/Chat-GPT-Image-Jan-20-2026-11-43-18-PM.png"
            alt="JOMOE Logo"
            class="logo animate-fadeIn"
          />
        </div>
        <nav class="nav">
          <a href="#">Home</a>
          <a href="#">Services</a>
          <a href="#" class="btn-orange">Book a Discovery call</a>
        </nav>
      </header>

      <!-- Main Content -->
      <div class="main-wrapper">
        <main>
          <section class="hero-section">
            <div class="hero-text">
              <h2 class="animate-fadeIn">
                Your Virtual Assistant.
              </h2>
              <div class="button-group">
                <button class="btn-orange">Let’s Talk</button>
                <button class="btn-dark">What We Do</button>
              </div>
            </div>
            <img
              src="https://i.ibb.co/N6LKfb78/dadcaaef-11bd-4bd4-b294-1ca6953d1571-Photoroom-1.png"
              alt="Hero Image"
              class="image"
            />
          </section>

          <section class="services-section">
            <div class="services-content">
              <p class="services-label">Administrative services</p>
              <h3>Services I offer</h3>
              <ul class="services-list">
                <li>Inbox &amp; email management</li>
                <li>Calendar management &amp; appointment scheduling</li>
                <li>Data entry</li>
                <li>Document formatting &amp; file organisation</li>
                <li>Customer support &amp; client follow-ups</li>
                <li>Invoicing &amp; basic admin bookkeeping</li>
                <li>Social media scheduling (content provided)</li>
              </ul>
            </div>
          </section>

          <section class="about-section">
            <div class="about-content">
              <p class="about-label">About</p>
              <h3>Dependable virtual support</h3>
              <p>
                Hi, I’m a dependable Virtual Administrator providing professional
                administrative support to busy professionals, start-ups, and small
                businesses. If you’re looking for someone organised, responsive, and
                easy to work with, I can help keep your day-to-day admin running smoothly.
                I work carefully, respect confidentiality, and follow instructions closely.
                I’m proactive with communication and always aim to deliver work on time
                and exactly as requested. I’m comfortable using Google Workspace,
                Microsoft Office, Zoom and I can quickly learn any systems you already use.
                Whether you need ongoing virtual admin support or help with a one-off task,
                I’m happy to start small so you can see how I work. I respond quickly and
                I’m happy to answer questions before you hire.
              </p>
            </div>
          </section>
        </main>
      </div>

      <!-- Footer -->
      <footer class="footer">
        <button class="btn-orange">Book a Call</button>
      </footer>
    </div>
    <ChatBot />
  </div>
</template>

<script>
import ChatBot from './components/ChatBot.vue';

export default {
  components: {
    ChatBot
  }
};
</script>

<style scoped>
#app {
  background-color: #DA9288;
  color: #F9ECD9;
  font-family: sans-serif;
  min-height: 100vh;
}

.container.full-width {
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 3rem;
  min-height: 100vh;
  padding: 2rem;
  width: 100%;
  max-width: none;
}

.main-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

main {
  max-width: 1200px;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.logo-container {
  margin-left: 1rem;
}

.logo {
  width: 192px;
  height: 192px;
  object-fit: contain;
}

.nav {
  display: flex;
  gap: 1.5rem;
  font-size: 1.2rem;
  align-items: center;
  flex-wrap: wrap;
}

.nav a {
  text-decoration: none;
  color: #F9ECD9;
}

.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
}

.hero-text h2 {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.3;
}

.button-group {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-orange {
  background-color: #EB8C37;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-orange:hover {
  background-color: #d97706;
}

.btn-dark {
  background-color: #1B2A41;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-dark:hover {
  background-color: #111827;
}

.image {
  max-width: 300px;
  width: 100%;
  margin: 0 auto;
  display: block;
}

.wave-text {
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  margin: 2rem 0;
}

.wave-text span {
  display: inline-block;
  animation: wave 2s ease-in-out infinite;
}

.wave-text span:nth-child(1) { animation-delay: 0s; }
.wave-text span:nth-child(2) { animation-delay: 0.2s; }
.wave-text span:nth-child(3) { animation-delay: 0.4s; }
.wave-text span:nth-child(4) { animation-delay: 0.6s; }
.wave-text span:nth-child(5) { animation-delay: 0.8s; }

@keyframes wave {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

.services-section {
  margin-top: 3rem;
  background-color: rgba(27, 42, 65, 0.2);
  border-radius: 24px;
  padding: 2.5rem;
}

.services-content {
  max-width: 720px;
}

.services-label {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.85rem;
  color: #1B2A41;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.services-section h3 {
  font-size: 2.2rem;
  margin-bottom: 1.5rem;
  color: #F9ECD9;
}

.services-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.85rem;
  font-size: 1.1rem;
  line-height: 1.5;
}

.services-list li {
  padding-left: 1.5rem;
  position: relative;
}

.services-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #EB8C37;
  font-size: 1.25rem;
  line-height: 1.1;
}

.about-section {
  margin-top: 2.5rem;
  padding: 2.5rem;
  border-radius: 24px;
  background-color: rgba(249, 236, 217, 0.15);
}

.about-content {
  max-width: 820px;
}

.about-label {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.85rem;
  color: #1B2A41;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.about-section h3 {
  font-size: 2.1rem;
  margin-bottom: 1.5rem;
  color: #F9ECD9;
}

.about-section p {
  font-size: 1.1rem;
  line-height: 1.7;
  margin: 0;
}

.image-center {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.footer {
  display: flex;
  background-color: #DA9288;
  justify-content: center;
  padding: 2rem 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.animate-fadeIn {
  animation: fadeIn 1s ease-in-out forwards;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .container.full-width {
    padding: 1.5rem 1rem;
    gap: 2rem;
  }

  .hero-section {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .nav {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%;
  }

  .header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .logo-container {
    margin-left: 0;
  }

  .hero-text h2 {
    font-size: 2.25rem;
  }

  .button-group {
    justify-content: center;
  }

  .image {
    max-width: 240px;
  }

  .services-section {
    padding: 2rem 1.5rem;
  }

  .services-content {
    margin: 0 auto;
  }

  .services-list li {
    text-align: left;
  }

  .about-section {
    padding: 2rem 1.5rem;
  }

  .about-content {
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .container.full-width {
    padding: 1.25rem 0.75rem;
  }

  .hero-text h2 {
    font-size: 2rem;
  }

  .button-group {
    flex-direction: column;
  }

  .button-group .btn-orange,
  .button-group .btn-dark {
    width: 100%;
    justify-content: center;
  }
}
</style>
